export enum CustomerStatus {
  ACTIVE = "active",
  SUSPENDED = "suspended",
}
